var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.14 3H4.86c-.25 0-.48.13-.61.35L1.2 8.64c-.13.23-.2.49-.2.75V13c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V9.39c0-.26-.07-.52-.2-.75l-3.05-5.29a.7.7 0 0 0-.61-.35M10 9v2H6V9H2.72l2.6-4.5h5.36l2.6 4.5z"
  })));
};
export default SvgInbox;